import styled, { keyframes, css } from 'styled-components'
import { colors, getFontStyle } from '@diversioteam/diversio-ds'

const backgroundShift = keyframes`
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
`

export const Container = styled.div<{ $noBackground?: boolean }>`
    min-height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(props) =>
        props.$noBackground
            ? 'transparent'
            : `linear-gradient(
        135deg,
        ${colors.primary10} 0%,
        ${colors.primary20} 25%,
        ${colors.primaryWhite} 50%,
        ${colors.primary20} 75%,
        ${colors.primary10} 100%
    )`};
    background-size: 400% 400%;
    ${(props) =>
        !props.$noBackground &&
        css`
            animation: ${backgroundShift} 10s ease infinite;
        `}
    position: relative;
    overflow: hidden;
`

export const ContentWrapper = styled.div`
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
`

export const BackgroundPattern = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    background-image:
        radial-gradient(circle at 20% 80%, ${colors.primary30} 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, ${colors.primary30} 0%, transparent 50%),
        radial-gradient(circle at 40% 40%, ${colors.primary20} 0%, transparent 50%);
    z-index: 0;
`

export const LoaderContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
`

export const LoadingText = styled.p`
    ${getFontStyle('p01Regular')}
    color: ${colors.primary60};
    margin: 0;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 0);
    margin-top: 80px; /* Adjust this based on the loader height */
`
